import { render } from "./SelectPrivate.vue?vue&type=template&id=5f58a28d&scoped=true"
import script from "./SelectPrivate.vue?vue&type=script&lang=js"
export * from "./SelectPrivate.vue?vue&type=script&lang=js"

import "./SelectPrivate.vue?vue&type=style&index=0&id=5f58a28d&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f58a28d"]])

export default __exports__